const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const $selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card-item',
};

document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  initWishlistGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  var products = event.detail.wishlist;
  if(products.length > 0){
    document.querySelector('.js-wishlist-header-icon').classList.add('active');
   if(document.querySelector('.js-wishlist-empty')){
    document.querySelector('.js-wishlist-empty').classList.add('hidden');
   }
  } else {
    document.querySelector('.js-wishlist-header-icon').classList.remove('active');
    if(document.querySelector('.js-wishlist-empty')){
     document.querySelector('.js-wishlist-empty').classList.remove('hidden');
    }
  }
  //console.log('Wishlist Updated', event.detail.wishlist);
  initWishlistGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  var products = event.detail.wishlist;
  if(products.length > 0){
    document.querySelector('.js-wishlist-header-icon').classList.add('active');
    if(document.querySelector('.js-wishlist-empty')){
     document.querySelector('.js-wishlist-empty').classList.add('hidden');
    }
  } else {
    document.querySelector('.js-wishlist-header-icon').classList.remove('active');
    if(document.querySelector('.js-wishlist-empty')){
     document.querySelector('.js-wishlist-empty').classList.remove('hidden');
    }
  }
  //console.log('Wishlist Product List Loaded',products.length, event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('Wishlist Buttons Loaded', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card-wishlist`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector($selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initWishlistButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
     if(button.classList.contains('wishlist-button-loaded') == false){
      button.classList.add('wishlist-button-loaded');
      button.addEventListener('click', () => {
        updateWishlist(productHandle);
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
      });
     }
  });
};

const initWishlistGrid = () => {
  const grid = document.querySelector($selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initWishlistButtons = () => {
  const buttons = document.querySelectorAll($selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

document.addEventListener("DOMContentLoaded", function() {
  var wishlistItems = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  if(wishlistItems != null){
     document.querySelector('.js-wishlist-header-icon').classList.add('active');
  } else {
     document.querySelector('.js-wishlist-header-icon').classList.remove('active');
  }
});

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};
